// extracted by mini-css-extract-plugin
export default {"editor":"editor_editor__ohe0h"};